module.exports = __webpack_public_path__ + "fonts/STKBureauSerif-Light.ecb159da1702c10c9382a0182eada372.eot";